<div class="select-datasource-body">
    <div class="select-datasource-body__section-head">
        <span class="select-datasource-body__section-title">Datasets</span>
        <span class="select-datasource-body__section-count">
            {{ datasets.length }} DATASET{{ datasets.length === 1 ? '' : 'S' }}
        </span>
    </div>

    <app-dataset-card
        *ngFor="let dataset of datasets; let i = index; trackBy: trackByDatasetId"
        [dataset]="dataset"
        [index]="i"
        [allDatasets]="datasets"
        [datasourceOptions]="datasourceOptions"
        [usedTableNames]="getUsedTableNames(dataset)"
        [canRemove]="!dataset.isPrimary"
        [hasReportAdminRole]="hasReportAdminRole"
        (configChanged)="onDatasetChanged()"
        (remove)="onRemoveDataset(dataset)">
    </app-dataset-card>

    <button type="button" class="select-datasource-body__add-dataset" [disabled]="!canAddDataset" (click)="onAddDataset()">
        <mat-icon aria-hidden="true">add</mat-icon>
        <span>Add dataset</span>
    </button>
</div>
